<template>
    <div class='overview-list'>
        <div class="project-list card">
            <header class="card-header">
                <div class=" card-header-title">
                    <h2 class="is-size-4">Projekter</h2>
                </div>
            </header>

            <div class="card-content">
                <overview-list-item v-for="project in projects" :key="project.id" :project="project" />

                <loader v-if="isLoading" text="Indlæser.." style="min-height: 300px" />

                <div v-else-if="!projects.length">
                    <p>Du har endnu ingen projekter.</p>

                    <router-link v-if="isCustomer" :to="{ name: 'students.search' }">
                        Find en studerende til dit første projekt idag.
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../global/styles/variables';

</style>

<script>
    import Loader from '@/global/components/Loader';
    import OverviewListItem from '@/taskflex/projects/components/OverviewListItem';
    import ProjectService from '@/taskflex/projects/services/ProjectService';
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                projects: [],
                isLoading: false,
                sort: 'created-asc',
                total: 0,
                page: 1,
                limit: 999,
            };
        },

        computed: {
            ...mapGetters('auth', [
                'isCustomer',
            ]),
        },

        mounted() {
            this.load();
        },

        methods: {
            load() {
                this.isLoading = true;

                const options = {
                    page: this.page,
                    limit: this.limit,

                    sortBy: this.resolveSort(),

                    includes: ['skill', 'student', 'customer', 'conversation'],

                };

                ProjectService.findAll(options, ({ data: { rows, total } }) => {
                    this.isLoading = false;

                    this.projects = rows;
                    this.total = total;
                });
            },

            resolveSort() {
                const [
                    key, direction,
                ] = this.sort.split('-');

                return {
                    key,
                    direction,
                };
            },
        },

        components: {
            Loader,
            OverviewListItem,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/projects/components/OverviewList.vue